import baseConfig from './config.base';


export default baseConfig;
